// extracted by mini-css-extract-plugin
export default {"container":"CE-z","dimension":"DE-z","dimensionLabels":"EE-z"};